export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-interpolate/src/number.js
// module id = YBRr
// module chunks = 0